import { render, staticRenderFns } from "./ShortCut.vue?vue&type=template&id=10e497eb"
import script from "./ShortCut.vue?vue&type=script&lang=js"
export * from "./ShortCut.vue?vue&type=script&lang=js"
import style0 from "./ShortCut.vue?vue&type=style&index=0&id=10e497eb&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e497eb')) {
      api.createRecord('10e497eb', component.options)
    } else {
      api.reload('10e497eb', component.options)
    }
    module.hot.accept("./ShortCut.vue?vue&type=template&id=10e497eb", function () {
      api.rerender('10e497eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/ShortCut.vue"
export default component.exports